import { useMemo } from 'react';

/**
 * Detect device performance tier: 'high' | 'mid' | 'low'
 * Uses deviceMemory + hardwareConcurrency (available on Chrome/Edge/Samsung)
 * Falls back to screen size + touch heuristics on Safari/Firefox
 */
export const getDeviceTier = () => {
  try {
    const mem = navigator.deviceMemory || 0;
    const cores = navigator.hardwareConcurrency || 0;

    // Explicit low-end: <=2GB RAM or <=2 cores
    if (mem > 0 && mem <= 2) return 'low';
    if (cores > 0 && cores <= 2) return 'low';

    // Explicit high-end: >=6GB RAM and >=6 cores
    if (mem >= 6 && cores >= 6) return 'high';

    // Touch device with small screen → likely mid/low phone
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const smallScreen = window.innerWidth < 768;
    if (isTouch && smallScreen) {
      // If we have no memory info (Safari), assume mid for iPhones
      if (mem === 0) return 'mid';
      if (mem <= 4) return 'mid';
    }

    return 'high';
  } catch {
    return 'mid';
  }
};

const tier = getDeviceTier();

export const useDeviceTier = () => useMemo(() => tier, []);

// Quick booleans
export const isLowEnd = tier === 'low';
export const isMidEnd = tier === 'mid';
export const isHighEnd = tier === 'high';
